import styles from './index.module.css'
import mixpanel from '@disco/api/mixpanel'

import React, { useEffect, useState } from 'react'
import localProvider from '@disco/services/upload/providers/local'
import type { UploadProvider } from 'types/upload'
import UploadOptions from 'components/common/upload/upload-options'
import FileDropWrapper from 'containers/FileDropWrapper'
import FeatureDescription from '../feature-description'
type Props = {
  onPickedFiles: (files: any[], provider: UploadProvider) => void
  onSkip?: () => void
}

const OnboardingSplashscreen = ({
  onPickedFiles,
  onSkip,
}: Props): React.ReactNode => {
  const [isOver, setIsOver] = useState(false)

  const onOver = newOver => {
    if (newOver !== isOver) {
      setIsOver(newOver)
    }
  }

  const handlePickedFiles = (files: File[], provider: UploadProvider) => {
    if (!files) return
    onPickedFiles(files, provider)
  }

  const handleChange = (files: File[]) => {
    handlePickedFiles(files, localProvider)
  }

  const handleSkip = () => {
    if (onSkip) {
      mixpanel.sendPureEvent('Skip onboarding splash screen')
      onSkip()
    }
  }

  useEffect(() => {
    mixpanel.sendPureEvent('See onboarding splash screen')
  }, [])
  return (
    <div className={styles.OnboardingSplashscreen}>
      <FileDropWrapper
        onDrop={handleChange}
        onOver={onOver}
        multiple
        className={styles.OnboardingSplashscreen__Container}
      >
        <FeatureDescription
          icon="upload-file"
          title="Drag and drop your files here to get started"
          description="or"
          center
        >
          <UploadOptions
            onPickedFiles={handlePickedFiles}
            importFileText="You can also import from:"
            showDivider
            onSkip={handleSkip}
          />
        </FeatureDescription>
      </FileDropWrapper>
    </div>
  )
}

export default OnboardingSplashscreen
